import { Phone } from "../../src/components/phoneUI/PhoneClass";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { chris } from "../characters/Chris";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { jenny } from "../characters/Jenny";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { merry } from "../characters/Merry";
import { doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V7JennyDateAfter } from "./V7";

export const V7JennyDate = async (): Promise<any> => {
    await mc.set((properties) => {
        properties.v7WentWithJennyDate = true;
    });
    empty.think(`*Buzz Buzz*`);
    if (Question.globalAnswers.v1WentToTheBarWith !== "vanessa" && mc.properties.annStatus !== "hate") {

        mc.think(`Like always... As soon as I get ready to sleep someone calls or texts...`);

    }
    await Phone.showMessagesUI({ name: jenny.name }, async () => {
        Phone.setMessage({ character: jenny.character, text: `Hey!`, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `Hey Jenny! What's up?` });

        Phone.setMessage({ character: jenny.character, text: `Bored...\nWhat are you doing?` });
        Phone.setMessage({ character: mc.character, text: `Nothing important.` });
        Phone.setMessage({ character: jenny.character, text: `How spontaneous are you?` });
        Phone.setMessage({ character: mc.character, text: `Very.` });
        Phone.setMessage({ character: jenny.character, text: `Wanna go somewhere?` });

        Phone.talk({ character: mc.character, text: `No way I'm gonna refuse!` });
        Phone.talk({ character: mc.character, text: ``, options: { wait: false } });

        Phone.setMessage({ character: mc.character, text: `Of course, what do you have in mind?` });
        Phone.setMessage({ character: jenny.character, text: `I feel like drinking.` });
        if (mc.properties.v7AnnChrisMovieStatus === "went") {
            Phone.talk({ character: mc.character, text: `Chris said his shift is about to start so I know the bar will be open.` });
            Phone.talk({ character: mc.character, text: `On the other hand, I don't think it's very smart going there after just being with him and Ann at the movie.` });
            Phone.talk({ character: mc.character, text: `But Jenny wants to drink and I don't know anywhere else.` });
            if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn) {

                Phone.talk({ character: mc.character, text: `I guess I'll have to take my chances.` });
            } else {

                Phone.talk({ character: mc.character, text: `Besides, he got some fun time with Ann, what about me?` });
                Phone.talk({ character: mc.character, text: `Fuck it! I'm gonna go there.` });
            }
        }
        Phone.talk({ character: mc.character, text: ``, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `I know a spot.` });
        Phone.setMessage({ character: jenny.character, text: `Great! Pick me up and we'll go.` });
        Phone.setMessage({ character: jenny.character, text: `My address is 404 Lincoln St.` });
        Phone.setMessage({ character: mc.character, text: `Omw.` });
        Phone.setMessage({ character: jenny.character, text: `Getting ready right now!` });
        Phone.closeMessagesUI();
    });


    return jump(V7JennyDate2, "V7JennyDate2");
};

export const V7JennyDate2 = async (): Promise<any> => {
    mc.think(`Nice! I've been waiting to go out with her.`);
    mc.think(`Damn, no way I'm picking her up with Emily's car.`);
    mc.think(`That leaves Joey. I hope he'll answer.`);

    return jump(V7JennyDateJoeyCar, "V7JennyDateJoeyCar");
};

export const V7JennyDateJoeyCar = async (): Promise<any> => {
    await Phone.showMessagesUI({ name: joe.name }, async () => {
        Phone.setMessage({ character: mc.character, text: `Yo Joey.`, options: { wait: false } });
        Phone.setMessage({ character: joe.character, text: `Sup bro!` });
        Phone.setMessage({ character: mc.character, text: `I was wondering if I can borrow your car.` });
        Phone.setMessage({ character: joe.character, text: `Only if it's for a good cause.` });
        Phone.setMessage({ character: mc.character, text: `It is.` });
        Phone.setMessage({ character: mc.character, text: `Remember the chick from the beach?` });
        Phone.setMessage({ character: joe.character, text: `How could I forget?` });
        Phone.setMessage({ character: mc.character, text: `She just texted me.` });
        Phone.setMessage({ character: mc.character, text: `She wants to go for a drink.` });
        Phone.setMessage({ character: joe.character, text: `My man!!! Are you taking her to our usual bar?` });
        Phone.setMessage({ character: mc.character, text: `Yeah.` });
        Phone.setMessage({ character: joe.character, text: `Damn! I'm kinda jealous right now... Haha.` });
        Phone.setMessage({ character: joe.character, text: `In that case, no way I'm gonna leave you hanging.` });
        Phone.setMessage({ character: joe.character, text: `Gimme a few minutes and I'll bring the car over.` });
        Phone.setMessage({ character: mc.character, text: `Thanks Joey you are the best!` });

        Phone.closeMessagesUI();
    });
    return jump(V7JennyDateJoeyCar2, "V7JennyDateJoeyCar2");
};

export const V7JennyDateJoeyCar2 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.BlackScreen);
    empty.think(`A few minutes later...`);
    if (Question.globalAnswers.v1WentToTheBarWith !== "vanessa" && mc.properties.annStatus !== "hate") {
        ImageClass.setImage(images.v5.Room2_2);
    } else {
        ImageClass.setImage(images.v7.V7RoomNight);

    }
    empty.think(`*Car horn sound*`);
    mc.think(`That must be Joey.`);
    ImageClass.setImage(images.v7.JoeBringsCar_0, { transition: true });
    mc.think(`I knew I could count on him! He got here damn quick.`);
    ImageClass.setImage(images.v7.JoeBringsCar_1);
    mc.talk(`Yo Joey!`);
    ImageClass.setImage(images.v7.JoeBringsCar_2);
    joe.talk(`I'm gonna drive out of here if you continue to call me Joey.`);
    mc.talk(`Sorry sorry, Joe.`);
    ImageClass.setImage(images.v7.JoeBringsCar_1);
    joe.talk(`Haha, I'm joking.`);
    ImageClass.setImage(images.v7.JoeBringsCar_3);
    joe.talk(`Anyway, the keys are inside. Have fun.`);
    joe.talk(`Oh yeah. And don't you dare to scratch it!`);
    mc.talk(`Don't worry.`);
    joe.talk(`And no cum stains on the leather as well!`);
    mc.talk(`I can't guarantee on that one.`);
    ImageClass.setImage(images.v7.JoeBringsCar_2);
    joe.talk(`${mc.name}!`);
    mc.talk(`Haha.`);
    ImageClass.setImage(images.v7.JoeBringsCar_1);
    joe.talk(`Have fun bro, don't forget to call me tomorrow and tell me how it was.`);
    mc.talk(`Of course.`);
    mc.talk(`By the way, do you need a ride home?`);
    joe.talk(`Nah, I'm just gonna walk home. It's close.`);
    mc.talk(`Cya Joey. Thanks again.`);
    joe.talk(`Have fun.`);
    ImageClass.setImage(images.v7.JoeBringsCar_4, { duration: 0.6 });
    mc.think(`Time to meet with Jenny.`);

    return jump(V7JennyDate3, "V7JennyDate3");
};

export const V7JennyDate3 = async (): Promise<any> => {
    doTransition(images.v7.JennyDate_0);
    mc.think(`I'm here... I think this is the address.`);
    jenny.talk(`${mc.name}!`, { method: "Shouting" });
    mc.think(`Ah? Where is she?`);
    jenny.talk(`Up here!`, { method: "Shouting" });
    ImageClass.setImage(images.v7.JennyDate_29);
    mc.think(`Oh, there she is.`);
    mc.talk(`Hey!`, { method: "Shouting" });
    jenny.talk(`I'll be right down!`, { method: `Shouting` });
    ImageClass.setImage(images.v7.JennyDate_0);
    mc.think(`Damn what was she wearing? I almost forgot how hot she is.`);
    mc.think(`Well. I'm about to get a closer look, here she comes.`);
    doWaitImageByTime(images.v7.JennyDate_2);
    jenny.talk(`Hey!`);
    return jump(V7JennyDate3_Question, "V7JennyDate3_Question");


};

export const V7JennyDate3_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_2);
    await mc.setQuestion(new Question({ text: `Hey Jenny.`, options: { think: false }, key: `v7JennyDateCheckedHerOut` })
        .option({ title: `Check her out`, key: true })
        .option({ title: `Don't check her out`, key: false }));


    if (Question.globalAnswers.v7JennyDateCheckedHerOut) {

        return jump(V7JennyDate3_Question_Check, "V7JennyDate3_Question_Check");
    } else {

        return jump(V7JennyDate3_Question_DontCheck, "V7JennyDate3_Question_DontCheck");
    }
};

export const V7JennyDate3_Question_Check = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_3);
    mc.think(`Hot legs...`);
    doWaitImageByTime(images.v7.JennyDate_4);
    mc.think(`Amazing body... Damn those boobs.`);
    if (Question.globalAnswers.v6JennySMSSentHerPic) {

        mc.think(`I know she sent me pics yesterday but nothing beats real life.`);
    } else {

    }
    ImageClass.setImage(images.v7.JennyDate_2);
    mc.talk(`You look amazing!`);
    mc.talk(`Now I feel bad for coming in my casual clothes.`);
    jenny.talk(`Haha, don't feel bad about it. I just like to gussy up.`);
    jenny.talk(`Are we ready to go?`);
    mc.talk(`Yeah. My car is right over there.`);

    return jump(V7JennyDate4, "V7JennyDate4");
};


export const V7JennyDate3_Question_DontCheck = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_2);
    jenny.talk(`Are we ready to go?`);
    mc.talk(`Yeah. My car is right over there.`);

    return jump(V7JennyDate4, "V7JennyDate4");
};

export const V7JennyDate4 = async (): Promise<any> => {
    doWaitImageByTime(images.v7.JennyDate_5);
    jenny.talk(`Finally I can relax. I've been working all day.`);
    jenny.talk(`My boss is giving me shit lately.`);
    jenny.talk(`Do this, do that.`);
    jenny.talk(`Like what the fuck? I know how to do my job! But she keeps nagging me.`);
    jenny.talk(`I work in a law office right now. I don't think I've told you.`);
    jenny.talk(`I'm just a simple secretary, but I'm studying law as I go.`);
    jenny.talk(`I plan on becoming a lawyer one day.`);
    jenny.talk(`My father was a lawyer. I just wanna follow his footsteps I guess...`);
    jenny.talk(`My brothers don't.`);
    jenny.talk(`I have three big brothers by the way. I am the little one in the family.`);
    mc.think(`I didn't remember her talking this much...`);
    jenny.talk(`The oldest is an engineer.`);
    jenny.talk(`The middle one is a bum. Just sitting on his ass and doing nothing.`);
    jenny.talk(`Still living with our parents...`);
    jenny.talk(`I keep telling him to do something with his life but he doesn't care about them.`);
    return jump(V7JennyDate4_Question, "V7JennyDate4_Question");
};

export const V7JennyDate4_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_5);
    await jenny.setQuestion(new Question({ text: `But it will come back to bite him in the ass... That's what life does.`, options: { think: false }, key: `v7JennyDateKeptListening` })
        .option({ title: `Keep listening`, key: true })
        .option({ title: `Drift away`, key: false }));


    if (Question.globalAnswers.v7JennyDateKeptListening) {

        return jump(V7JennyDate4_Question_Listen, "V7JennyDate4_Question_Listen");
    } else {

        return jump(V7JennyDate4_Question_Drift, "V7JennyDate4_Question_Drift");
    }
};

export const V7JennyDate4_Question_Listen = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_5);
    jenny.talk(`They say that the last kid is usually the most successful right?`);
    jenny.talk(`Not my case... Haha.`);
    jenny.talk(`But I'm getting there, I just don't wanna stress myself out too much.`);
    jenny.talk(`I believe that if I keep doing my thing everything will work out eventually.`);
    jenny.talk(`That's why I keep going to the beach every time I can. That's what I love doing and I don't wanna give that up for a raise.`);
    jenny.talk(`Don't get me wrong, a raise could be nice. But I prefer to enjoy life.`);
    jenny.talk(`I'm that kinda girl that doesn't need much. I just wanna be happy. Does that make sense?`);
    mc.talk(`Of course.`);
    jenny.talk(`But you know what they say... You can't go to the grocery store with happiness. So I guess I'm still finding the right balance.`);
    jenny.talk(`It's either that. Or I guess I'll have to find me a sugar daddy. Haha.`);

    return jump(V7JennyDate5, "V7JennyDate5");
};

export const V7JennyDate4_Question_Drift = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_6);
    mc.talk(`Uh-huh.`);
    if (Question.globalAnswers.v7JennyDateCheckedHerOut) {

        mc.think(`I can't get enough of those legs.`);
    } else {
        mc.think(`Damn... Nice legs.`);

    }
    mc.think(`I better focus so I don't crash.`);
    return jump(V7JennyDate5, "V7JennyDate5");
};

export const V7JennyDate5 = async (): Promise<any> => {
    doWaitImageByTime(images.v7.JennyDate_7, { transition: true });
    mc.talk(`Here we are.`);
    jenny.talk(`You know that I've never been to this side of the city?`);
    mc.talk(`Really? Why not?`);
    jenny.talk(`I don't know. It's far from my home. And to tell you the truth... I almost never go out at night.`);
    jenny.talk(`Not anymore... Even now it's past my bedtime.`);
    jenny.talk(`But it's nice knowing someone who knows his way around the city. Thanks.`);
    mc.talk(`Let's go have a seat.`);
    doWaitImageByTime(images.v7.JennyDate_8);

    if (Game.seenScenarios.includes(`V6ChrisMerry`) || Game.seenScenarios.includes("V5ChrisRandomGirl")) {
        if (Question.globalAnswers.v5FuckedMerryAss) {
            if (Game.seenScenarios.includes(`V6VanessaCustomerMeeting`)) {
                mc.think(`What the fuck? Merry is here again? Doesn't she have a life?`);
                mc.think(`Well... I'm here as well. So I can't really blame her for doing the same.`);
                mc.think(`But at least I'm not coming alone.`);
            } else {
                mc.think(`Holy shit, is that Merry?`);
                mc.think(`What bad timing, I hope she doesn't realize it's me.`);
            }
        } else {
            mc.think(`Is that Merry sitting over there?`);
            mc.think(`Good thing I haven't done anything with her... Could've been awkward.`);
        }
    } else {

        mc.think(`Just as I thought... The place is almost empty.\nOnly Chris is here and another girl.`);
    }

    if (Question.globalAnswers.v4NoJoeyWasMeanToChris) {
        ImageClass.setImage({ ...images.v7.JennyDate_9, partialsToDisplay: [images.v7.JennyDate_9.partials.JennyDate_9_2_p] });
        chris.talk(`${mc.name}.`);
        mc.think(`Is he still angry at me because I was mean to him during Joey's birthday?`);
        mc.talk(`Hey Chris. Can we order?`);
        chris.talk(`What do you want?`);
        jenny.talk(`Whiskey for me.`);
        mc.talk(`Make it a double.`);
        mc.talk(`Thanks.`);
    } else {
        ImageClass.setImage(images.v7.JennyDate_9);
        if (mc.properties.v7AnnChrisMovieStatus === "went") {
            chris.talk(`${mc.name}? I didn't expect to see you here.`);
            chris.talk(`Why didn't you say anything, I would've given you a ride.`);
            mc.talk(`It wasn't planned.`);
            chris.talk(`Haha, I got you.`);
            chris.talk(`Anyway, what can I get for you?`);
        } else if (mc.properties.v7AnnChrisMovieStatus === "refused") {

            chris.talk(`Why didn't you come with us to see the movie?`);
            mc.talk(`I didn't feel like it.`);
            chris.talk(`It was boring anyway.`);
            mc.talk(`Just as I thought...`);
            chris.talk(`Anyway, what can I get for you?`);
        } else {
            mc.talk(`Hey Chris.`);
            chris.talk(`What can I get for you?`);
        }

        jenny.talk(`Whiskey for me.`);
        ImageClass.setImage(images.v7.JennyDate_33.partials.JennyDate_33_p);
        mc.talk(`Make it a double.`);
        chris.talk(`A girl that drinks whiskey by choice? You won the jackpot.`);
        mc.talk(`Haha.\nWhere can we sit?`);
        chris.talk(`Wherever you like.`);
        mc.talk(`Thanks.`);
    }

    return jump(V7JennyDate6, "V7JennyDate6");
};

export const V7JennyDate6 = async (): Promise<any> => {
    doWaitImageByTime(images.v7.JennyDate_11);
    if (Question.globalAnswers.v4NoJoeyWasMeanToChris) {
        jenny.talk(`He doesn't like you that much, doesn't he?`);
        mc.talk(`Long story.`);
        jenny.talk(`Tell me.`);
        mc.talk(`There isn't really much to tell... He tried talking to me but I wasn't really in the mood.`);
        jenny.talk(`I can't blame you, it happens to me as well.`);
        jenny.talk(`Especially if people try to talk to me before I've had my morning coffee! Haha.`);
    } else {
        jenny.talk(`You are really popular! He was happy to see you. Is he a close friend of yours?`);
        mc.talk(`Not really. I know him from here.`);
        jenny.talk(`Even more impressive!`);
        jenny.talk(`It's hard to get bartenders to remember you most of the time.`);

        if (mc.properties.v7AnnChrisMovieStatus === "went") {
            jenny.talk(`By the way, what were you talking about? Were you just with him?`);
            mc.talk(`Yeah, but it's not important.`);
            jenny.talk(`Oh, ok. I don't like sticking my nose where it doesn't belong.`);
        } else if (mc.properties.v7AnnChrisMovieStatus === "refused") {
            jenny.talk(`What was he talking about? What movie?`);
            mc.talk(`Fifthly Greys of Sasha.`);
            jenny.talk(`Really? You went to see that with him? Haha.`);
            mc.talk(`We had another female friend with us.`);
            mc.think(`No way I'm telling her about Ann. That would be extremely stupid.`);
            jenny.talk(`Oh. That's explains it.`);
        }
    }


    mc.talk(`Anyway! Whiskey, huh?`);
    return jump(V7JennyDate6_Question, "V7JennyDate6_Question");

};

export const V7JennyDate6_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_11);
    await jenny.setQuestion(new Question({ text: `Haha, weren't you listening? I've already told you I grew up in a house filled with men, so yeah... Whiskey and beer are my thing.`, options: { think: false }, key: `v7JennyDateLikedThatSheDrinksBeer` })
        .option({ title: `I like it`, key: true })
        .option({ title: `I prefer girls that drink wine`, key: false }));


    if (Question.globalAnswers.v7JennyDateLikedThatSheDrinksBeer) {

        return jump(V7JennyDate6_Question_Like, "V7JennyDate6_Question_Like");
    } else {

        return jump(V7JennyDate6_Question_DontLike, "V7JennyDate6_Question_DontLike");
    }

};


export const V7JennyDate6_Question_Like = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_11);
    await mc.set((properties) => {
        properties.jennyRelationship++;
    });

    mc.talk(`I like it.`);
    mc.talk(`I usually drink beer but I couldn't let you drink whiskey by yourself.`);
    jenny.talk(`Wise choice! I hate drinking alone.`);
    jenny.talk(`Not that I drink that much, but when I do, I prefer company.`);
    mc.talk(`Makes sense, so do I.`);

    return jump(V7JennyDate7, "V7JennyDate7");
};


export const V7JennyDate6_Question_DontLike = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_11);
    await mc.set((properties) => {
        properties.jennyRelationship--;
    });

    mc.talk(`I prefer girls that drink wine.`);
    jenny.talk(`Really? I didn't think of you as the stereotype guy.`);
    mc.talk(`What can I do... That's my preference.`);
    jenny.talk(`Well. You'll have to deal with me drinking it then.`);
    mc.talk(`I don't have a problem with that, I even ordered the same.`);
    return jump(V7JennyDate7, "V7JennyDate7");
};

export const V7JennyDate7 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_11);
    chris.talk(`${mc.name}!`, { method: "Shouting" });
    ImageClass.setImage(images.v7.JennyDate_12);
    chris.talk(`Your order is ready.`, { method: "Shouting" });

    if (!Question.globalAnswers.v4NoJoeyWasMeanToChris) {
        ImageClass.setImage(images.v7.JennyDate_30);
        chris.talk(`Here are the two whiskey you ordered.`);
        mc.talk(`Thanks Chris.`);
        if (mc.properties.v7AnnChrisMovieStatus === "went") {
            chris.talk(`Do you have a moment?`);
            mc.talk(`Sure.`);
            chris.talk(`I didn't want to ruin it for you, but since we are alone now we can talk more freely.`);
            ImageClass.setImage(images.v7.JennyDate_31);
            if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn) {
                if (Question.globalAnswers.v7AnnChrisMoviesTouchedAnn) {
                    chris.talk(`I saw that you and Ann were hitting it off at the theater.`);
                    mc.talk(`You could say that.`);
                    chris.talk(`Damn, bro. When I met her I had no idea she would turn out to be that wild.`);
                    chris.talk(`It's not that I'm jealous! I just hate being third wheel, you know?`);
                    mc.talk(`Yes, I can understand.`);
                    mc.talk(`But you let me choose to share a sit with her. So it was an easy decision for me.`);
                    chris.talk(`I would have done the same.`);
                    chris.talk(`I just wanted to say that everything is fine and we are cool.`);
                    mc.talk(`That's great.`);
                } else {
                    chris.talk(`I'm curious why didn't you make a move on Ann.`);
                    mc.talk(`Why did I need to do that? I can make as many as moves as I want when we are at home.`);
                    mc.talk(`It's not like we haven't had sex before.`);
                    chris.talk(`I understand.`);
                    chris.talk(`I was just surprised that you had her to yourself and didn't do nothing, because I certainly would have.`);
                    mc.talk(`Yeah, I figured.`);
                }

            } else if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn === false) {
                chris.talk(`I bet that you saw what was going on during the movie right?`);
                mc.talk(`I did.`);
                chris.talk(`I hope it didn't bother you.`);
                if (Question.globalAnswers.v7AnnChrisMoviesAgreeToChrisTouchingHer) {
                    mc.talk(`It didn't.`);
                    chris.talk(`Glad to hear it! I didn't want to make you feel uncomfortable.`);
                    mc.talk(`Don't worry about it. I could've let her sit on my lap.`);
                    chris.talk(`Yeah, I know! I appreciate it.`);
                    mc.talk(`Anyway, I have important things to take care of right now.`);
                } else {
                    mc.talk(`A bit.`);
                    chris.talk(`Sorry, bro.\nI didn't mean to make you feel uncomfortable, but you know how it is right? Haha.`);
                    chris.talk(`She sat on my leg and I got so damn horny.`);
                    chris.talk(`I was surprised she didn't stop me.`);
                    chris.talk(`I guess you are training her well! Haha.`);
                }
            }
            if (mc.properties.agreeToChrisProposal) {

                chris.talk(`One last thing before you go.`);
            } else {

            }
        } else if (mc.properties.v7AnnChrisMovieStatus === "refused") {
            ImageClass.setImage(images.v7.JennyDate_32);
            chris.talk(`Have you talked to Ann yet?`);
            mc.talk(`Not yet, why?`);
            chris.talk(`No reason.`);
            mc.think(`What is he hiding?`);
            chris.talk(`Let's just say I appreciate it.\nAnyway, just ask her.`);
            mc.talk(`I'll do that.`);
            return jump(V7JennyDate8, "V7JennyDate8");
        }

    } else {

    }
    if (mc.properties.agreeToChrisProposal) {

        return jump(V7ChrisMcAgreementConv, "V7ChrisMcAgreementConv");
    } else {

    }

    if (Question.globalAnswers.v4NoJoeyWasMeanToChris) {

        ImageClass.setImage(images.v7.JennyDate_32);
        chris.talk(`Here are the two whiskey you ordered.`);
        return jump(V7JennyDate7_Question, "V7JennyDate7_Question");
    } else {

    }

    if (mc.properties.agreeToChrisProposal == undefined && Question.globalAnswers.v1EnableNTR) {
        chris.talk(`Before you go.\nDo you have a minute?`);
        mc.talk(`Sure. What's it about?`);
        return jump(V7JennyDate8SuggestExchange, "V7JennyDate8SuggestExchange");
    } else {

    }

    return jump(V7JennyDate8, "V7JennyDate8");
};

export const V7JennyDate7_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_32);
    await mc.setQuestion(new Question({ text: `This is the time to apologize to him if I choose to.`, options: { think: true }, key: `v7JennyDateApologizedToChris` })
        .option({ title: `Apologize`, key: true })
        .option({ title: `Don't Apologize`, key: false }));


    if (Question.globalAnswers.v7JennyDateApologizedToChris) {

        return jump(V7JennyDate7_Question_Apologize, "V7JennyDate7_Question_Apologize");
    } else {

        return jump(V7JennyDate7_Question_DontApologize, "V7JennyDate7_Question_DontApologize");
    }
};


export const V7JennyDate7_Question_Apologize = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_32);
    await mc.set((properties) => {
        properties.chrisStatus = "friend";
    });
    mc.talk(`Chris, I wanted to apologize about the other day when I was an asshole to you.`);
    ImageClass.setImage(images.v7.JennyDate_32.partials.JennyDate_32_2_p);
    chris.talk(`Yeah that wasn't cool bro.`);
    chris.talk(`The only reason I came was to ask you something.`);
    ImageClass.setImage(images.v7.JennyDate_30);
    chris.talk(`But I'm not gonna be some nagging chick and hold a grudge.`);
    chris.talk(`I appreciate that you apologized.`);
    mc.talk(`So we are good?`);
    chris.talk(`Yeah, it's history now.`);
    mc.talk(`By the way, what did you wanna talk about?`);
    chris.talk(`Well. If you really wanna know.`);
    return jump(V7JennyDate8SuggestExchange, "V7JennyDate8SuggestExchange");
};

export const V7JennyDate7_Question_DontApologize = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_32);
    mc.think(`Fuck it. Who cares if he likes me or not.`);

    return jump(V7JennyDate8, "V7JennyDate8");
};



export const V7JennyDate8SuggestExchange = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_31);
    chris.talk(`Take a look at the girl that is sitting at the end of the bar.`);
    ImageClass.setImage(images.v7.JennyDate_31_2);
    mc.talk(`What about her?`);

    ImageClass.setImage(images.v7.JennyDate_31);
    chris.talk(`I want to offer you a deal.`);
    chris.talk(`That girl is just one of many girls that are coming here and are just looking for a good time, if you know what I mean.`);

    chris.talk(`But sometimes I want to meet girls that bars aren't their usual hangout place.`);
    chris.talk(`And I believe you don't meet girls in bars that often.`);
    mc.talk(`Right.`);
    chris.talk(`So what I want to say is that I'll be happy to point the girls I meet at your direction once I'm done with them as long as you do the same.`);
    if (mc.properties.annStatus === "hate") {
        mc.talk(`Aren't you dating Ann?`);
        chris.talk(`Dating...`);
        chris.talk(`We are hanging out.`);
        mc.talk(`Does she feel the same way?`);
        ImageClass.setImage(images.v7.JennyDate_32);
        chris.talk(`That's not the point right now.`);
        mc.talk(`If you say so...`);
        chris.talk(`Just answer my question.`);

    } else {

    }

    return jump(V7JennyDate8SuggestExchange_Question, "V7JennyDate8SuggestExchange_Question");
};

export const V7JennyDate8SuggestExchange_Question = async (): Promise<any> => {

    ImageClass.setImage(images.v7.JennyDate_31);
    await chris.setQuestion(new Question({ text: "Don't worry. We're not gonna do it right now.\nI'll let you go back to your date.", options: { think: false }, key: `v7JennyDateAgreeToChrisProposal` })
        .option({ title: `Agree`, key: true })
        .option({ title: `Disagree`, key: false }));


    if (Question.globalAnswers.v7JennyDateAgreeToChrisProposal) {
        return jump(V7JennyDate8SuggestExchange_Question_Agree, "V7JennyDate8SuggestExchange_Question_Agree");

    } else {
        return jump(V7JennyDate8SuggestExchange_Question_Disagree, "V7JennyDate8SuggestExchange_Question_Disagree");

    }
};


export const V7JennyDate8SuggestExchange_Question_Agree = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_31);
    await mc.set((properties) => {
        properties.agreeToChrisProposal = true;
    });
    mc.talk(`Sounds good.`);
    chris.talk(`Great!`);
    ImageClass.setImage(images.v7.JennyDate_30);
    chris.talk(`So that's settles it!`);
    chris.talk(`Expect a call from me soon!`);
    return jump(V7JennyDate8, "V7JennyDate8");
};


export const V7JennyDate8SuggestExchange_Question_Disagree = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_31);
    await mc.set((properties) => {
        properties.agreeToChrisProposal = false;
    });
    mc.talk(`I think I'll pass.`);
    chris.talk(`Too bad bro.`);
    chris.talk(`Well, hit me up if you ever change your mind.`);
    mc.talk(`Sure, cya.`);

    return jump(V7JennyDate8, "V7JennyDate8");
};


export const V7ChrisMcAgreementConv = async (): Promise<any> => {
    if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn === undefined) {

        ImageClass.setImage(images.v7.JennyDate_30);
        chris.talk(`Wait hold on.`);
    } else {

    }
    // <if>
    // 	<conditions>
    // 		<param name="question.answered" nequals="22080003012021G0"/>
    // 	</conditions>
    // 	<do>
    // 	</do>
    // </if>

    ImageClass.setImage(images.v7.JennyDate_31);
    chris.talk(`Who's that girl?`);
    mc.talk(`That's Jenny.`);
    chris.talk(`Sweet Bro! She's hot.`);
    mc.talk(`I agree. Haha.`);
    if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn != undefined) {
        chris.talk(`I knew you are a player, I bet Ann didn't even fell asleep and you are already here with some other chick.`);
        if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn) {
            chris.talk(`The reason I'm bringing it up is to make sure you haven't forgotten about our little agreement.`);
            if (Question.globalAnswers.v7AnnChrisMoviesTouchedAnn) {
                chris.talk(`You fooled around with Ann today, and now you are here with this girl.`);

            }
            if (Question.globalAnswers.v5FuckedMerryAss != undefined) {
                chris.talk(`And don't forget you did whatever with Merry over there, the girl I hooked you up with.`);

            }

            chris.talk(`So, I was wondering when I'm gonna get my cut.`);
        } else {

        }

    } else {
        chris.talk(`So, are you done with Ann?`);
        mc.talk(`Not at all... Why?`);
        chris.talk(`Oh, I see.`);
        chris.talk(`I am asking because of our little agreement.\nI hope you haven't forgotten about it.`);
        mc.talk(`I haven't.`);
        chris.talk(`So, when am I going to get my share?`);
    }

    if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn == false) {
        chris.talk(`Anyway, I just wanted to make sure you haven't forgotten about our agreement.`);
        mc.talk(`Jenny made you grow an appetite?`);
        chris.talk(`Haha, you can say that.`);
        chris.talk(`But I won't bug you too much right now since you were a real bro today when you let me share the sit with Ann.`);
        chris.talk(`I left it in your hands, and you honored the agreement.`);
        chris.talk(`So thanks again.`);
    } else {
        if (Question.globalAnswers.v5GaveMerryAnotherChance) {

            if (Question.globalAnswers.v5FuckedMerryAss) {
                mc.talk(`You told me to send girls at your way when I'm done with them. I ain't done yet.`);
                chris.talk(`Are you blue balling me bro?`);
                mc.talk(`Nah. Trust me.`);
                ImageClass.setImage(images.v7.JennyDate_30);
                chris.talk(`Great!`);
            } else {
                mc.talk(`Really? I've only gotten a blowjob from that girl, Merry.`);
                chris.talk(`It's one blowjob I haven't gotten.`);
                mc.talk(`Bro, you told me to send girls your way when I'm done with them.`);
                mc.talk(`I'm not done just yet.`);
                chris.talk(`Fine. I'll wait but don't blue ball me.`);
                mc.talk(`I won't!`);
            }



        } else if (Question.globalAnswers.v5GaveMerryAnotherChance == false) {
            mc.talk(`I haven't done shit with Merry, she is not my type, so I am waiting for mine as well.`);
            chris.talk(`But at least I suggested her to you.`);
            mc.talk(`This was your deal in the first place, so it's obvious that you should share first.`);
            mc.talk(`I'm still in, but I'm waiting for a girl I'd like.`);
            chris.talk(`Gotcha.`);
            chris.talk(`Maybe I have the right girl for you.\nExpect a call from me soon!`);
            mc.talk(`Haha, great.`);
        }

    }


    chris.talk(`Anyway, that's all I wanted to say.`);
    return jump(V7JennyDate8, "V7JennyDate8");


};

export const V7JennyDate8 = async (): Promise<any> => {

    ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_13_p] });
    jenny.talk(`Thanks!`);
    jenny.talk(`So. I feel like I've been talking about myself so much.\nWhat about you?`);
    mc.talk(`What do you want to know?`);

    return jump(V7JennyDate9_Questions, "V7JennyDate9_Questions");
};

export const V7JennyDate9_Questions = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_13_p] });
    let jennyQuestion = `I don't care, anything you'd like to talk about.`;
    let endConv = `I don't have anything interesting to tell`;
    if (Question.globalAnswers.v7JennyDateQuestionsArr && Question.globalAnswers.v7JennyDateQuestionsArr?.length > 0) {
        jennyQuestion = `What else?`;
        endConv = `End conversation`;

    } else {

    }

    await jenny.setQuestion(new Question({ text: jennyQuestion, options: { array: "v7JennyDateQuestionsArr", think: false }, key: `v7JennyDateQuestions` })
        .option({ title: `Talk about your parents`, key: `parents`, hide: Question?.globalAnswers?.v7JennyDateQuestionsArr?.includes(`parents`) })
        .option({ title: `Talk about Emily`, key: `emily`, hide: Question?.globalAnswers?.v7JennyDateQuestionsArr?.includes(`emily`) })
        .option({ title: `Talk about your computer`, key: `computer`, hide: Question?.globalAnswers?.v7JennyDateQuestionsArr?.includes(`computer`) })
        .option({ title: `Talk about your future`, key: `future`, hide: Question?.globalAnswers?.v7JennyDateQuestionsArr?.includes(`future`) })
        .option({ title: endConv, key: `end` }));


    if (Question.globalAnswers.v7JennyDateQuestions === "parents") {

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`I can talk about my parents.`);
        ImageClass.setImage(images.v7.JennyDate_14);
        jenny.talk(`What do they do?`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`My father is a consultant for startup companies and my mom assists him.`);
        ImageClass.setImage(images.v7.JennyDate_14);
        jenny.talk(`Oh! I heard there is a lot of money in that profession.`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`We don't have any financial problems so I guess you are right.`);
        ImageClass.setImage(images.v7.JennyDate_14);
        jenny.talk(`That must be nice.`);
        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_13_p] });
        jenny.talk(`Not that I'm complaining or anything, haha. I never missed anything in my life, but I guess it would have been nice to be rich, you know?`);
        jenny.talk(`I love what I do. But there are days that I wished I wouldn't need to wait for my alarm clock to ring...`);
        ImageClass.setImage(images.v7.JennyDate_14);
        jenny.talk(`I guess it depends on the day.`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`I can see your point.`);
        ImageClass.setImage(images.v7.JennyDate_14);
        jenny.talk(`I'm glad you do.`);
        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_13_p] });
        jenny.talk(`There are people that walk among us that like to wake up early in the morning, like whaaat? I never understood that.`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`You and me both, haha.`);
    } else if (Question.globalAnswers.v7JennyDateQuestions === "emily") {
        await mc.set((properties) => {
            properties.emilyRelationship++;
            properties.jennyRelationship++;
        });


        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`Well, I currently live in my house with my ${emily.properties.relation}.`);
        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_13_p] });
        jenny.talk(`Is she older than you?`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`She is.`);
        ImageClass.setImage(images.v7.JennyDate_14);
        jenny.talk(`So you grew up being the youngest one, just like me!`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`Haha, yeah, but we are just two so the house wasn't so crowded.`);
        jenny.talk(`I can agree.`);
        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_13_p] });
        jenny.talk(`It's funny but right now I live with one roommate and I kinda miss the noise.`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`If you're lucky a noisy neighbor will move to your block. That will fix the problem.`);
        jenny.talk(`Haha!`);
        jenny.talk(`Nah, I'm good I think.`);
    } else if (Question.globalAnswers.v7JennyDateQuestions === "computer") {
        await mc.set((properties) => {
            properties.jennyRelationship--;

            ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        });
        mc.talk(`I really like just sitting on my computer.`);
        ImageClass.setImage(images.v7.JennyDate_14);
        jenny.talk(`Really? What's interesting about that?`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`Everything, it's a full world you can explore.`);
        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_13_p] });
        jenny.talk(`Ah... I don't really get on well with computers.`);
        jenny.talk(`I need to use a computer at my work and let me tell you, it's a NIGHTMARE!`);
        ImageClass.setImage(images.v7.JennyDate_14);
        jenny.talk(`It keeps getting stuck all of the time.`);
        jenny.talk(`We have a computer specialist and I think he hates my guts! Haha.`);
        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_13_p] });
        jenny.talk(`I keep calling him like ten times a day, every day!`);
        jenny.talk(`Poor guy... But that's his job so he has to deal with it!`);
        ImageClass.setImage(images.v7.JennyDate_14);
        jenny.talk(`Anyway, I like the outdoors anyway... The computer can stay at my work.`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`Well. You are missing out.`);
        jenny.talk(`Maybe... But I guess I'm just too old to change my habits at this point.`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_13_p] });
        mc.talk(`Yeah...`);
    } else if (Question.globalAnswers.v7JennyDateQuestions === "future") {
        await mc.set((properties) => {
            properties.jennyRelationship++;
        });

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`Lately I've started to think about my future. What I wanna be or do.`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`I'm not sure yet. But I know I wanna do something I like.`);
        ImageClass.setImage(images.v7.JennyDate_14);
        jenny.talk(`That's the most important thing!`);
        jenny.talk(`If you have a chance to do something you like, do it! I'm currently working where I work because I needed money...`);
        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_13_p] });
        jenny.talk(`It's not like it's bad, but if I had someone to support me, I guess I would have chosen something else.`);
        jenny.talk(`But it is what it is.`);
        ImageClass.setImage(images.v7.JennyDate_14);
        jenny.talk(`I hope that I don't sound jealous! I'm honestly happy for you.`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`Thanks, but I'm still in the thinking stage, so we'll see what will happen.`);
        jenny.talk(`Don't forget to keep my updated!`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`I will.`);
    } else {

        return jump(V7JennyDate10, "V7JennyDate10");
    }

    return jump(V7JennyDate9_Questions, "V7JennyDate9_Questions");
};

export const V7JennyDate10 = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_13_p] });

    if (Question.globalAnswers.v7JennyDateQuestionsArr && Question.globalAnswers.v7JennyDateQuestionsArr.length === 1) {

        mc.talk(`I don't have anything interesting to tell.`);
        jenny.talk(`Really? Nothing at all?`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`I'm more of the listening type.`);
        jenny.talk(`So we are a match, because I kinda like talking.`);
        jenny.talk(`But I want to know more about you...\nMaybe as the time goes on.`);

        ImageClass.setImage({ ...images.v7.JennyDate_14, partialsToDisplay: [images.v7.JennyDate_14.partials.JennyDate_14_p] });
        mc.talk(`In time.\nFor now you can tell me more about you.`);
    } else {

    }

    ImageClass.setImage(images.v7.JennyDate_14);
    jenny.talk(`You love hearing me talk don't you?`);
    ImageClass.setImage(images.v7.JennyDate_14.partials.JennyDate_13_p);
    jenny.talk(`Well, I don't remember if I said it, but I'm really glad you agreed to go out with me.`);
    jenny.talk(`I was sitting at home, and after a long time I felt like I needed to go out.`);
    jenny.talk(`And you were the only person that came into my mind to text.`);
    ImageClass.setImage(images.v7.JennyDate_14);
    jenny.talk(`I'm glad you agreed to come out and join me tonight.`);
    mc.talk(`Of course, I'm glad you texted.`);
    ImageClass.setImage(images.v7.JennyDate_14.partials.JennyDate_13_p);
    mc.talk(`Especially after those pics yesterday.`);
    ImageClass.setImage(images.v7.JennyDate_14);
    jenny.talk(`Haha, oh those.`);
    jenny.talk(`Would you believe me if I said I don't normally do that?`);
    jenny.talk(`I don't know why, but I really wanted to do that.`);
    jenny.talk(`I guess it worked because we are sitting here right now.`);
    mc.talk(`It was hot. I'm still can't get it out of my head.`);
    ImageClass.setImage(images.v7.JennyDate_14);
    jenny.talk(`Who knows... Maybe I'll be in the mood to send new ones in the future?`);

    if (Question.globalAnswers.v5GaveMerryAnotherChance) {

        return jump(V7JennyDate10_Merry, "V7JennyDate10_Merry");
    }
    if (ann.properties.isCorrupted && mc.properties.agreeToChrisProposal) {

        return jump(V7JennyDate10_MerryFirstMeeting, "V7JennyDate10_MerryFirstMeeting");
    } else {

    }
    return jump(V7JennyDate11, "V7JennyDate11");
};

export const V7JennyDate10_MerryFirstMeeting = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_22);
    mc.think(`The girl that Chris told me about just stood up.`);

    ImageClass.setImage(images.v7.JennyDate_23, { duration: 0.6 });
    mc.think(`What the fuck? Why is she looking at me?\nIs she coming here?`);
    ImageClass.setImage(images.v7.JennyDate_24, { duration: 0.6 });
    mc.think(`The fuck?`);
    ImageClass.setImage(images.v7.JennyDate_25.partials.JennyDate_25_p, { duration: 0.6 });
    merry.talk(`Hey.`);
    ImageClass.setImage(images.v7.JennyDate_25.partials.JennyDate_25_2_p);
    mc.talk(`Hey...?`);
    ImageClass.setImage(images.v7.JennyDate_26.partials.JennyDate_26_p, { duration: 0.6 });
    merry.talk(`Who is she?`);
    jenny.talk(`She is... Jenny.`);
    merry.talk(`Hey.`);
    jenny.talk(`Hey.`);
    ImageClass.setImage(images.v7.JennyDate_24.partials.JennyDate_24_2_p, { duration: 0.6 });
    empty.think(`...`);
    mc.talk(`Ah... Do you need something?`);
    ImageClass.setImage(images.v7.JennyDate_25.partials.JennyDate_25_p, { duration: 0.6 });
    merry.talk(`No.`);
    empty.think(`...`);
    ImageClass.setImage(images.v7.JennyDate_26.partials.JennyDate_26_2_p);
    jenny.talk(`Ah... Are you two friends? Or...?`);
    ImageClass.setImage(images.v7.JennyDate_26.partials.JennyDate_26_p, { duration: 0.6 });
    merry.talk(`No.`);
    jenny.talk(`Oh.`);
    ImageClass.setImage(images.v7.JennyDate_24.partials.JennyDate_24_2_p, { duration: 0.6 });
    empty.think(`...`);
    ImageClass.setImage(images.v7.JennyDate_26.partials.JennyDate_26_p, { duration: 0.6 });
    jenny.talk(`So? Do you need anything?`);
    ImageClass.setImage(images.v7.JennyDate_25.partials.JennyDate_25_p, { duration: 0.6 });
    merry.talk(`Are you busy?`);
    mc.talk(`I am.`);
    merry.talk(`Ok.`);
    ImageClass.setImage(images.v7.JennyDate_19, { duration: 0.6 });
    mc.think(`She went back to her sit.`);
    ImageClass.setImage({ ...images.v7.JennyDate_17, partialsToDisplay: [images.v7.JennyDate_17.partials.JennyDate_17_p] });
    jenny.talk(`What was that about?`);
    mc.talk(`Believe me that I have no clue.`);
    ImageClass.setImage(images.v7.JennyDate_17);
    jenny.talk(`Are you sure? She seems weird.`);
    mc.talk(`You read my mind.`);

    return jump(V7JennyDate11, "V7JennyDate11");
};

export const V7JennyDate10_Merry = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_22);

    mc.think(`Oh, shit. I think Merry noticed me.`);
    ImageClass.setImage(images.v7.JennyDate_23, { duration: 0.6 });
    mc.think(`I hope she isn't coming...`);
    ImageClass.setImage(images.v7.JennyDate_24, { duration: 0.6 });
    mc.think(`here...`);
    mc.think(`Oh shit...`);
    mc.think(`Well, it's not like I'm her boyfriend or anything.`);
    ImageClass.setImage(images.v7.JennyDate_25.partials.JennyDate_25_2_p);
    merry.talk(`Hey. `);
    ImageClass.setImage(images.v7.JennyDate_25.partials.JennyDate_25_p, { duration: 0.6 });
    mc.talk(`Hey Merry.`);
    ImageClass.setImage(images.v7.JennyDate_26.partials.JennyDate_26_p, { duration: 0.6 });
    merry.talk(`Who is she?`);
    jenny.talk(`She is... Jenny.`);
    merry.talk(`Hey.  `);
    jenny.talk(`Hey.   `);
    ImageClass.setImage(images.v7.JennyDate_24.partials.JennyDate_24_2_p, { duration: 0.6 });
    empty.think(`... `);
    mc.talk(`Ah... Do you need something?`);
    ImageClass.setImage(images.v7.JennyDate_25.partials.JennyDate_25_p, { duration: 0.6 });
    merry.talk(`No. `);
    empty.think(`...  `);
    ImageClass.setImage(images.v7.JennyDate_26.partials.JennyDate_26_2_p);
    jenny.talk(`Ah... Are you two friends? Or...?`);
    ImageClass.setImage(images.v7.JennyDate_26.partials.JennyDate_26_p, { duration: 0.6 });
    merry.talk(`No.   `);
    jenny.talk(`Oh.    `);
    ImageClass.setImage(images.v7.JennyDate_24.partials.JennyDate_24_2_p, { duration: 0.6 });
    empty.think(`...      `);
    ImageClass.setImage(images.v7.JennyDate_26.partials.JennyDate_26_p, { duration: 0.6 });
    jenny.talk(`So? Do you need anything?`);
    ImageClass.setImage(images.v7.JennyDate_25.partials.JennyDate_25_p, { duration: 0.6 });
    merry.talk(`Are you busy?`);
    mc.talk(`I am.`);
    merry.talk(`Ok. `);
    ImageClass.setImage(images.v7.JennyDate_19, { duration: 0.6 });
    mc.think(`She went back to her sit.`);
    ImageClass.setImage({ ...images.v7.JennyDate_17, partialsToDisplay: [images.v7.JennyDate_17.partials.JennyDate_17_p] });

    jenny.talk(`What was that about?`);
    mc.talk(`Nothing to worry about.`);
    ImageClass.setImage(images.v7.JennyDate_17);
    jenny.talk(`Are you sure? She seems weird.`);
    mc.talk(`She is, but she is harmless.`);
    jenny.talk(`If you say so.`);

    return jump(V7JennyDate11, "V7JennyDate11");
};

export const V7JennyDate11 = async (): Promise<any> => {
    doWaitImageByTime(images.v2_5.BlackScreen);
    empty.think(`Some time has passed.`);

    ImageClass.setImage(images.v7.JennyDate_14);

    jenny.talk(`I think it's time to get going.`);
    mc.talk(`I agree.`);
    doTransition(images.v7.JennyDate_27);
    mc.talk(`Here we are.`);
    jenny.talk(`Thanks! I had a wonderful time.`);
    return jump(V7JennyDate11_Question, "V7JennyDate11_Question");
};


export const V7JennyDate11_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_27);
    await mc.setQuestion(new Question({ text: `Me too.`, options: { think: false }, key: `v7JennyDateKissedHer` })
        .option({ title: `Kiss her`, key: true })
        .option({ title: `Don't kiss her`, key: false }));


    if (Question.globalAnswers.v7JennyDateKissedHer) {

        return jump(V7JennyDate11_Question_Kiss, "V7JennyDate11_Question_Kiss");
    } else {

        return jump(V7JennyDate11_Question_DontKiss, "V7JennyDate11_Question_DontKiss");
    }
};

export const V7JennyDate11_Question_Kiss = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_28);
    await mc.set((properties) => {
        properties.jennyRelationship++;
    });
    jenny.talk(`Muah.`);
    return jump(V7JennyDate11_Question_Kiss_Question, "V7JennyDate11_Question_Kiss_Question");
};

export const V7JennyDate11_Question_Kiss_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_28);
    await jenny.setQuestion(new Question({ text: `Mmm...`, options: { think: false }, key: `v7JennyDateTriedToGoFurther` })
        .option({ title: `Try to go further`, key: true })
        .option({ title: `Stop`, key: false }));


    if (Question.globalAnswers.v7JennyDateTriedToGoFurther) {
        return jump(V7JennyDate11_Question_Kiss_Question_Further, "V7JennyDate11_Question_Kiss_Question_Further");

    } else {
        return jump(V7JennyDate11_Question_Kiss_Question_DontGoFurther, "V7JennyDate11_Question_Kiss_Question_DontGoFurther");

    }
};


export const V7JennyDate11_Question_Kiss_Question_Further = async (): Promise<any> => {
    doWaitImageByTime(images.v7.JennyDate_34);
    await mc.set((properties) => {
        properties.jennyRelationship--;
    });
    mc.think(`She has soft legs...`);

    ImageClass.setImage(images.v7.JennyDate_35);
    jenny.talk(`No...`);
    jenny.talk(`Not today.`);
    mc.think(`Can't blame me for trying.`);
    if (mc.properties.jennyRelationship >= 8) {

        jenny.talk(`I hope you don't take that the wrong way.`);
        jenny.talk(`I like you, but that will have to wait for another time.`);
    } else {

    }
    mc.talk(`I understand.`);
    mc.think(`Not really...`);
    ImageClass.setImage(images.v7.JennyDate_27);
    jenny.talk(`Anyway. Good night!`);
    mc.talk(`Good night, Jenny.`);
    return jump(V7JennyDateEnd, "V7JennyDateEnd");
};

export const V7JennyDate11_Question_Kiss_Question_DontGoFurther = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_28);
    await mc.set((properties) => {
        properties.jennyRelationship++;
    });
    ImageClass.setImage(images.v7.JennyDate_27);
    jenny.talk(`Thank you ${mc.name}, I had a wonderful time. I hope we can do it again. Soon.`);
    mc.talk(`We will.`);
    jenny.talk(`I'm glad.`);
    jenny.talk(`Good night!`);
    mc.talk(`Good night, Jenny.`);
    return jump(V7JennyDateEnd, "V7JennyDateEnd");
};


export const V7JennyDate11_Question_DontKiss = async (): Promise<any> => {
    ImageClass.setImage(images.v7.JennyDate_27);
    await mc.set((properties) => {
        properties.jennyRelationship--;
    }); jenny.talk(`Ah... Good night ${mc.name}.`);
    mc.talk(`You too Jenny.`);
    return jump(V7JennyDateEnd, "V7JennyDateEnd");

};

export const V7JennyDateEnd = async (): Promise<any> => {

    return jump(V7JennyDateAfter, "V7JennyDateAfter");
};


